exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stackSettings{height:25px;padding:0;line-height:25px;display:flex;flex-flow:row nowrap;color:var(--ink-70)}.stackSettingsList{display:block;flex:1;list-style:none;margin:0;padding:0;display:flex;align-items:flex-start}.stackSettingsListItem{margin:0 5px;padding:0}.stackSettingsLabel{-webkit-user-select:none;-moz-user-select:none;user-select:none;display:inline-flex;flex-flow:row nowrap;align-items:center;height:25px}.stackSettingsSelect{margin:0 5px;font-size:11px}.stackSettingsCheckbox{margin:0 5px}", ""]);

// exports
